import { render, staticRenderFns } from "./CompanyTagFormDialog.vue?vue&type=template&id=15b241f0&scoped=true"
import script from "./CompanyTagFormDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyTagFormDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanyTagFormDialog.vue?vue&type=style&index=0&id=15b241f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b241f0",
  null
  
)

export default component.exports